import { IToken } from '../typings/token';
import { ITemporaryAstNode } from '../typings/ast-node';
import composeTokens from './composes';


export function compose(tokens: IToken[]) {
    const asts = tokens.map(token => {
        return { token, type: 'Temporary' } as ITemporaryAstNode;
    });
    return composeTokens(asts);
}
